'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { useLocation } from '@marketplace-web/shared/browser'
import { getContentWithThreadId } from '_libs/utils/faq'

import HelpCenterFaqEntryTrackingEvent from '../../../../../app/pages/HelpCenter/HelpCenterFaqEntryTrackingEvent'

type Props = {
  faqEntryId: number
  title: string | null | undefined
  content: string | null | undefined
  xhrRequest?: boolean
  accessChannel?: string
}

const HelpCenterFaqContent = ({
  faqEntryId,
  title,
  content,
  xhrRequest = false,
  accessChannel,
}: Props) => {
  const { thread_id } = useLocation().searchParams

  return (
    <article className="faq__question-answer faq-content faq-content--accordion">
      <HelpCenterFaqEntryTrackingEvent faqEntryId={faqEntryId} accessChannel={accessChannel} />
      {!xhrRequest && <Spacer />}
      {!!title && <Text as="h1" type={Text.Type.Heading} text={title} />}
      {!!title && <Spacer size={Spacer.Size.Large} />}
      {!!content && (
        <Text
          as="span"
          text={getContentWithThreadId(content, thread_id)}
          width={Text.Width.Parent}
          html
        />
      )}
    </article>
  )
}

export default HelpCenterFaqContent
